module.exports = __webpack_public_path__ + "img/qrcode-ycxt_258.56141470.jpg";